import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    icon: '🏦',
    subtitle: 'Blindaje de Pesos: La Cascada que Hace Rendir Cada Peso',
    desc: 'Ningún peso duerme más. Cascada de billeteras ordenada por TNA, timing de pagos que genera rendimiento extra y sistema de cashback que devuelve plata en cada compra. Sin conocimientos financieros previos.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '🛒',
    subtitle: 'Ingeniería del Supermercado: El Método Anti-Inflación',
    desc: 'La matriz de descuentos cruzados que reduce el ticket entre 25% y 40%. Estrategia de stockeo inteligente, compras en días correctos, marcas blancas estratégicas y mayoristas sin ser mayorista.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }, {
    icon: '💵',
    subtitle: 'Dólar y Resguardo: El Escudo Contra Cada Devaluación',
    desc: 'MEP legal desde el celular en 20 minutos. USDT accesible desde $500. Dollar Cost Averaging mensual sin adivinar el timing. Earn en dólares mientras el capital espera.',
    color: 'from-[#16a34a]/10 to-transparent',
    border: 'border-t-[#16a34a]'
  }, {
    icon: '💳',
    subtitle: 'Gestión de Deudas y Tarjetas: De Enemigo a Herramienta',
    desc: 'Apalancamiento inverso que financia el banco en lugar de financiarte a vos. Cuotas sin interés que se licúan con la inflación. Negociación bancaria con guión exacto. Método de liberación definitivo.',
    color: 'from-[#15803d]/10 to-transparent',
    border: 'border-t-[#15803d]'
  }, {
    icon: '📈',
    subtitle: 'Generación de Ingresos Micro: La Segunda Fuente',
    desc: 'Protocolo de 72 horas para el primer ingreso extra. Plataformas locales y globales que pagan en pesos y en dólares. Liquidación de activos olvidados. Escalada hacia retenciones mensuales.',
    color: 'from-[#22c55e]/10 to-transparent',
    border: 'border-t-[#22c55e]'
  }, {
    icon: '🧠',
    subtitle: 'Psicología y Protocolo 911: La Mente Que Sostiene Todo',
    desc: 'El sistema mental para no tomar decisiones destructivas en el peor momento. Protocolo de crisis en 3 niveles con pasos exactos. Pirámide de prioridades de pagos. Ritual mensual que automatiza el sistema.',
    color: 'from-[#4ade80]/10 to-transparent',
    border: 'border-t-[#4ade80]'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-6xl mx-auto" data-id="element-400">
      <FadeIn data-id="element-401">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-402">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-403">
            📚
          </span>{' '}
          LOS 6 TOMOS DEL SISTEMA
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-404">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-405">
            <motion.div whileHover={{
          y: -5,
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className={`bg-white border border-[#e2e8f0] ${tomo.border} border-t-4 hover:border-[#22c55e] transition-all rounded-2xl p-4 md:p-8 h-full flex flex-col relative overflow-hidden shadow-sm hover:shadow-xl`} data-id="element-406">
              <div className={`absolute inset-0 bg-gradient-to-b ${tomo.color} opacity-50 pointer-events-none`} data-id="element-407"></div>

              <div className="absolute top-3 right-3 md:top-4 md:right-4 text-[10px] md:text-xs font-black tracking-widest text-[#16a34a] bg-[#f8fafc] px-2 py-0.5 md:px-3 md:py-1 rounded-full border border-[#e2e8f0]" data-id="element-408">
                TOMO 0{index + 1}
              </div>

              <div className="text-4xl md:text-6xl mb-3 md:mb-6 relative z-10 drop-shadow-sm" data-id="element-409">
                {tomo.icon}
              </div>

              <h3 className="text-lg md:text-xl font-black text-[#0f172a] mb-1.5 md:mb-2 relative z-10" data-id="element-410">
                {tomo.subtitle}
              </h3>

              <p className="text-sm md:text-base text-[#475569] font-medium leading-relaxed flex-grow relative z-10" data-id="element-411">
                {tomo.desc}
              </p>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}